
import { Shaders, GLSL } from "gl-react";

export const shaders = Shaders.create({
  lutApplier: {
    frag: GLSL`
    #define LUT_FLIP_Y
    #define LUT_NO_CLAMP

    precision highp float;

    varying vec2 uv;

    uniform sampler2D image;
    uniform sampler2D lut;
    uniform vec2 coverUv;
    uniform float percentage;

    vec4 lookup(vec4 textureColor, sampler2D lookupTable) {
        #ifndef LUT_NO_CLAMP
            textureColor = clamp(textureColor, 0.0, 1.0);
        #endif

        highp float blueColor = textureColor.b * 63.0;

        highp vec2 quad1;
        quad1.y = floor(floor(blueColor) / 8.0);
        quad1.x = floor(blueColor) - (quad1.y * 8.0);

        highp vec2 quad2;
        quad2.y = floor(ceil(blueColor) / 8.0);
        quad2.x = ceil(blueColor) - (quad2.y * 8.0);

        highp vec2 texPos1;
        texPos1.x = (quad1.x * 0.125) + 0.5/512.0 + ((0.125 - 1.0/512.0) * textureColor.r);
        texPos1.y = (quad1.y * 0.125) + 0.5/512.0 + ((0.125 - 1.0/512.0) * textureColor.g);

        #ifdef LUT_FLIP_Y
            texPos1.y = 1.0-texPos1.y;
        #endif

        highp vec2 texPos2;
        texPos2.x = (quad2.x * 0.125) + 0.5/512.0 + ((0.125 - 1.0/512.0) * textureColor.r);
        texPos2.y = (quad2.y * 0.125) + 0.5/512.0 + ((0.125 - 1.0/512.0) * textureColor.g);

        #ifdef LUT_FLIP_Y
            texPos2.y = 1.0-texPos2.y;
        #endif

        highp vec4 newColor1 = texture2D(lookupTable, texPos1);
        highp vec4 newColor2 = texture2D(lookupTable, texPos2);

        highp vec4 newColor = mix(newColor1, newColor2, fract(blueColor));
        return newColor;
    }

    void main() {
        // Get the image color
        vec2 adjustedUv = uv * coverUv;
        vec4 rawColor = texture2D(image, adjustedUv);

        // Apply 3D LUT color transform
        vec4 color = lookup(rawColor, lut);

        vec4 finalColor = mix(rawColor, color, percentage);
        gl_FragColor = clamp(finalColor, 0.0, 1.0);
    }
`,
  },
});
